import { FormControlLabel, Switch } from '@mui/material';

interface IFeatureFlagToggle {
    flagName: string;
    isEnabled: boolean;
    onToggle: (flagName: string, isEnabled: boolean) => void;
    label: string;
}

/**
 *
 * The FeatureFlagToggle component is a reusable switch control used to enable or disable specific feature flags in a user's preferences. It integrates with a feature flag management system (such as feature flags stored in user preferences) and provides an easy way to toggle these flags on or off.
 * This component is useful for managing feature toggles in a user-facing settings page, allowing users to enable or disable specific experimental or optional features.
 * It is intended to be used in conjunction with the useFeatureFlagEditor hook during editing without changing the current users settings. The useFeatureFlagEditor manages the state of feature flags and provides a function to update them but does not save or change any settings in CurrentUserContainer.
 *
 * See sample usage in AccountSettingsPage.tsx.
 *
 */

export default function FeatureFlagToggle({ flagName, isEnabled, onToggle, label }: IFeatureFlagToggle) {
    const handleToggle = () => {
        onToggle(flagName, !isEnabled);
    };

    return (
        <FormControlLabel
            value="start"
            control={<Switch checked={isEnabled} onChange={handleToggle} />}
            label={label}
            labelPlacement="end"
        />
    );
}
